// src/components/BusinessSuite/schedule/api/scheduleApi.js
import axiosInstance from '../../../../api/axiosInstance';

export const getPlanningConfig = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/schedule/config`).then(r => r.data);

export const getServiceProviders = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/service-providers`).then(r => r.data);

export const getEmployeeSchedules = async (businessId, start, end) =>
  axiosInstance.get(`/businesses/${businessId}/schedules`, { params: { start, end } }).then(r => r.data);

export const saveEmployeeSchedule = async (businessId, payload) =>
  axiosInstance.post(`/businesses/${businessId}/schedules`, payload).then(r => r.data);

export const getTimeOffRequests = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/time-off`).then(r => r.data);

export const actOnTimeOffRequest = async (businessId, id, status) =>
  axiosInstance.patch(`/businesses/${businessId}/time-off/${id}`, { status }).then(r => r.data);

export const getSickLeaves = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/sick-leaves`).then(r => r.data);

export const getMinEmployeeConfigs = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/min-employee-configs`).then(r => r.data);

export const getScheduleRules = async (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/schedule-rules`).then(r => r.data);

export const getApprovedTimeOff = (businessId) =>
  axiosInstance.get(`/businesses/${businessId}/time-off`, { params:{ upcoming:true } })
               .then(r => r.data);
